import usePendingState from '../../Hooks/usePendingState';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';
import { InputFileImage } from './InputFileImage';
import { InputQuillEditor } from './InputQuillEditor';

const FormEditFeatured = () => {
    const { setNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const [featuredData, setFeaturedData] = useState({
        titulo: '',
        previa: '',
        conteudo: '',
        img: '',
        publicado: '',
    });

    const [featuredErrorData, setFeaturedErrorData] = useState({
        titulo: [],
        previa: [],
        conteudo: [],
        img: [],
        publicado: [],
    });

    const [imageUploading, setImageUploading, imageUploadingRef] = usePendingState();
    const [formLoading, setFormLoading, formPendingRef] = usePendingState();

    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFeaturedData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleImageCrop = (croppedImage, fileExtenstion, name) => {
        setFeaturedData((prevData) => ({
            ...prevData,
            [name]: croppedImage,
        }));
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current || imageUploadingRef.current) return;
        setFormLoading(true);

        try {
            const formData = new FormData();

            Object.keys(featuredData).forEach((key) => {
                if (key !== 'img') {
                    if (typeof featuredData[key] === 'boolean') {
                        formData.append(key, featuredData[key] ? 1 : 0);
                    } else {
                        formData.append(key, featuredData[key]);
                    }
                }
            });

            if (featuredData.img) {
                formData.append('img', featuredData.img);
            }

            const response = await fetch(`${baseUrl}/manager/destaques/novo/`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });
            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: 'Destaque adicionado com sucesso!',
                    show: true,
                });
                navigate('/manager/destaques');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();
                    setFeaturedErrorData(errors);
                } else {
                    throw new Error('Erro ao adicionar novo destaque.');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );

    return (
        <>
            <Link
                to="/manager/destaques"
                className="bg-slate-100 px-4 py-1.5 rounded border border-slate-300 float-right ml-2 transition-all hover:bg-slate-200"
            >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Voltar
            </Link>

            <h4 className="mb-6 text-xl font-bold text-black">Adicionar destaque</h4>

            <div className="flex flex-col">
                <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Título</label>
                                <input
                                    type="text"
                                    name="titulo"
                                    value={featuredData.titulo}
                                    onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, titulo: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {featuredErrorData.titulo && featuredErrorData.titulo[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {featuredErrorData.titulo[0]}{' '}
                                        <span
                                            onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, titulo: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Prévia</label>
                                <textarea
                                    name="previa"
                                    value={featuredData.previa}
                                    onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, previa: [] }))}
                                    onChange={handleChange}
                                    rows="4"
                                    className="w-full px-3 py-1.5 2xl:py-2 resize-none border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {featuredErrorData.previa && featuredErrorData.previa[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {featuredErrorData.previa[0]}{' '}
                                        <span
                                            onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, previa: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Conteúdo</label>
                                <InputQuillEditor
                                    name="conteudo"
                                    toolbar={['Bold', 'Italic', 'Underline', 'Image', 'Link', 'List']}
                                    value={featuredData.conteudo}
                                    onChange={handleChange}
                                    disabled={formLoading || imageUploading}
                                    onUploadStateChange={setImageUploading}
                                />
                                {featuredErrorData.conteudo && featuredErrorData.conteudo[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {featuredErrorData.conteudo[0]}{' '}
                                        <span
                                            onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, conteudo: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex flex-col lg:flex-row">
                            <div className="w-1/2">
                                <label className="block text-sm font-medium">Imagem</label>

                                <InputFileImage
                                    name="img"
                                    imagem={`/assets/img/admin/image-select.png`}
                                    size={{ largura: '1000', altura: '700' }}
                                    allowCrop={true}
                                    onImageCrop={handleImageCrop}
                                />
                                {featuredErrorData.img && featuredErrorData.img[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {featuredErrorData.img[0]}{' '}
                                        <span
                                            onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, img: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/4">
                                <label className="block text-sm font-medium mb-1">Publicado em</label>
                                <input
                                    type="datetime-local"
                                    name="publicado"
                                    value={featuredData.publicado}
                                    onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, publicado: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {featuredErrorData.publicado && featuredErrorData.publicado[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {featuredErrorData.publicado[0]}{' '}
                                        <span
                                            onClick={() => setFeaturedErrorData((prevData) => ({ ...prevData, publicado: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading || imageUploading}
                        aria-busy={formLoading || imageUploading}
                        className="w-full lg:w-3/4 bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {imageUploading ? 'Enviando imagem...' : !formLoading ? 'Salvar' : <Loading />}
                    </button>
                </form>
            </div>
        </>
    );
};

export default FormEditFeatured;
